module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/settings-e26f6e92131d718437722cf98935bb09.svg";